export default __webpack_public_path__ + "static/media/BISON.26bfc8cb.png";